module.exports = __webpack_public_path__ + "img/苏州瑞尚汽车交易市场有限公司.e7e1d116.png";